import React from 'react';
import { observer } from 'mobx-react';
import { FlexDiv } from '../../design-system/containers';
import { TextLead } from '../../design-system/texts';

function EmailAvatar({ ui, desktopOnly, mobileOnly }) {
    const { email } = ui;
    const { from_name, avatar_background_color } = email;

    return (
        <FlexDiv
            borderRadius="50"
            backgroundColor={avatar_background_color || '#2E56E4'}
            padding={8}
            height={40}
            minWidth={40}
            width={40}
            alignCenter
            justifyCenter
            desktopOnly={desktopOnly}
            mobileOnly={mobileOnly}
        >
            <TextLead color="white" bold>
                {from_name
                    .split(' ')
                    .map((n) => n[0])
                    .join('')}
            </TextLead>
        </FlexDiv>
    );
}

export default observer(EmailAvatar);
